module.exports = __webpack_public_path__ + "img/Helfer_Fm.86ad69bf.svg";